<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../lib/Common/Http/UrlUtil";
    import HttpRequestOption from "../../lib/Common/Http/HttpRequestOption";
    import {HttpRequestUtil} from "../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../component/common/Value/ArraySlotView.svelte";
    import CreatedUpdatedView from "../../component/common/Value/CreatedUpdatedView.svelte";


    let isLoading = false;
    let users = null;

    onMount(() => {
        loadData();
    });

    function loadData() {
        const params = {};


        const url = UrlUtil.createApiUrl("admin/user", params);

        const option = HttpRequestOption.createForGet();
        option.signalId = "AdminRUser";
        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            const body = response['body'];
            users = body['users'];

            //


        }, option);
    }

</script>

<div class="admin-user-list-page standard-page">
    <h1>ユーザー</h1>

    <div>
        <LoadingContentView isLoading={isLoading}>
            <ArraySlotView array={users}>
                <table>
                    <thead>
                    <tr>
                        <th>最終ログイン</th>
                        <th>id</th>
                        <th>所属</th>
                        <th>名前</th>
                        <th>作成更新情報</th>

                    </tr>
                    </thead>
                    <tbody>
                    {#each users as user}
                        <tr>
                            <td class="login-information">
                                <div>
                                    { user.last_logged_in_at }
                                </div>
                                <div class="sub">
                                    <span>
                                        { user.last_access_from_ip }
                                    </span>
                                    <span>
                                    { user.logged_in_count }回

                                    </span>
                                </div>
                            </td>
                            <td class="id">{ user.id }</td>
                            <td class="company-department-job">
                                <div>
                                    { user.company_name }
                                </div>
                                <div>
                                    { user.department_name }
                                </div>
                                <div>
                                    { user.job_name }
                                </div>
                            </td>
                            <td>{ user.name }</td>
                            <td>
                                <CreatedUpdatedView model={user}/>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </ArraySlotView>
        </LoadingContentView>

    </div>


</div>
<style lang="scss">
    .admin-user-list-page {
        table {
            tbody {
                tr {
                    td {
                        &.login-information {
                            .sub {
                                display: flex;
                                gap: 2em;
                                font-size: 0.75em;
                                opacity: 0.75;
                            }
                        }

                        &.id {
                            font-size: 0.75em;
                            opacity: 0.75;
                        }

                        &.company-department-job {
                            font-size: 0.75em;
                            opacity: 0.75;
                        }
                    }
                }
            }
        }
    }
</style>